
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.176 14.055a.857.857 0 00.867-.856.89.89 0 00-.275-.638l-3.68-3.563 3.68-3.568a.854.854 0 00-.592-1.483.811.811 0 00-.598.24L5.377 8.295a.996.996 0 00-.243.328 1.028 1.028 0 00-.08.375c0 .133.026.256.077.37.05.112.133.224.246.333l4.201 4.113c.16.16.36.24.598.24z","fill":"#757F8A","fill-rule":"evenodd"}})])
          )
        }
      }
    